<template>
<ion-app main>
  <ion-header>
    <ion-toolbar color="primary">
      <ion-buttons slot="start">
        <ion-button @click="openEnd">
          <ion-icon name="menu"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Inventario<span v-if="yo.permiso_visualizaCostos && filtros.mostrarCostos && costoTotal">: {{costoTotal | currency}}</span></ion-title>
    </ion-toolbar>
    <ion-progress-bar type="indeterminate" v-if="cargando" />
  </ion-header>
  <ion-content class="content">
    <ion-row>
      <ion-col size-xs="12" :size-md="mostrarResultados?4:12" :size-lg="mostrarResultados?3:12">
        <ion-list>
          <ion-item @click="seleccionarTipo">
            <ion-label>Mostrar tipo</ion-label>
            <ion-input readonly class="ion-text-right" :value="filtros.tipoEquipo!=''?filtros.tipoEquipo:'Todos'" />
          </ion-item>
          <ion-item>
            <ion-label>En posesión de</ion-label>
            <ion-select :value="filtros.tipoPosesion" v-on:ionChange="setFiltro('tipoPosesion',$event.detail.value)">
              <ion-select-option v-for="t in tiposPosesiones" :key="t">{{t}}</ion-select-option>
            </ion-select>
          </ion-item>
          <!--ion-item v-if="filtros.tipoPosesion=='Cliente'">
            <ion-label>Cliente</ion-label>
            <ion-select :value="filtros.idCliente" v-on:ionChange="setFiltro('idCliente',$event.detail.value)">
              <ion-select-option :value="''">Todos</ion-select-option>
              <ion-select-option v-for="c in clientes" :key="c._id" :value="c._id">{{c.alias || c.nombre}}</ion-select-option>
            </ion-select>
          </ion-item-->
          <ion-item @click="seleccionarCliente" v-if="filtros.tipoPosesion=='Cliente'">
            <ion-label position="stacked">Cliente</ion-label>
            <ion-input readonly color="primary" :value="(cliente||{}).nombre || '(Sin cliente)'" />
          </ion-item>
          <ion-item v-if="yo.permiso_visualizaCostos">
            <ion-label>Mostrar costos</ion-label>
            <ion-checkbox slot="end" :checked="filtros.mostrarCostos" v-on:ionChange="setFiltro('mostrarCostos',$event.detail.checked==true)"></ion-checkbox>
          </ion-item>
          <ion-item>
            <ion-label>Sólo inventariable</ion-label>
            <ion-checkbox slot="end" :checked="filtros.soloInventariable" v-on:ionChange="setFiltro('soloInventariable',$event.detail.checked==true)"></ion-checkbox>
          </ion-item>
          <ion-row>
            <ion-col>
              <ion-button @click="buscar" expand="block" :fill="!mostrarResultados?'solid':'outline'">
                <i class="icon ion-ios-search"></i>&nbsp;Buscar
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-list>
        <pre v-if="!modoProduccion">{{filtros}}</pre>
      </ion-col>
      <ion-col size-xs="12" size-md="8" size-lg="9" v-if="mostrarResultados">
        <ion-list>
          <ion-item-divider>Resultados ({{Object.keys(piezas).length}})</ion-item-divider>
          <ion-item v-for="(pieza) in piezasOrdenadas" :key="pieza.idEquipo" @click="$router.push('/catalogos/equipos/'+pieza.idEquipo+'/modo/historial')">
            <ion-label text-wrap v-if="pieza.equipo">
              <h2 class="ion-text-capitalize">{{pieza.equipo.marca}} {{pieza.equipo.modelo}}</h2>
              <p>Numero de serie: {{pieza.equipo.sn}}</p>
              <p v-if="filtros.tipoEquipo==''">{{pieza.equipo.tipo}}</p>
              <p v-if="pieza.cliente && filtros.idCliente==''">Cliente: {{pieza.cliente.nombre}}</p>
              <p>Custodia: {{pieza.tipoCustodia}}</p>
            </ion-label>
            <ion-label text-wrap v-else>
              <pre>{{pieza}}</pre>
            </ion-label>
            <ion-note slot="end" v-if="empresa.calcularCostos && pieza.equipo && yo.permiso_visualizaCostos && filtros.mostrarCostos">{{pieza.equipo.costo | currency}}</ion-note>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
  </ion-content>
</ion-app>
</template>
<script>
import Api from '@/components/Api/Api'
import TiposEquipos from '@/models/TiposEquipos'
import TiposCustodia from '@/models/TiposCustodia'
import ModalSeleccionarCliente from '@/components/ModalSeleccionarCliente'
export default {
  name: 'Inventario',
  data() {
    return {
      yo: Api.fetchLocal('cmms.yo') || {},
      modoProduccion: Api.modoProduccion,
      empresa: {},
      cargando: true,
      mostrarResultados: false,
      piezas: {},
      piezasOrdenadas: [],
      tiposEquipos: [],
      tiposPosesiones: [],
      clientes: [],
      cliente: {},
      filtros: {
        tipoEquipo: '',
        tipoPosesion: 'Cliente',
        idCliente: '',
        mostrarCostos: (Api.fetchLocal('cmms.yo') || {}).rol == 'administrador',
        soloInventariable: false
      },
      costoTotal: 0,
      precioTotal: 0,
      modal: null
    }
  },
  methods: {
    openEnd() {
      Api.$emit('open-menu')
    },
    setFiltro(campo, valor) {
      this.filtros[campo] = valor
      console.log("setFiltro", campo, valor)
    },
    async buscar() {
      this.mostrarResultados = false
      await Api.wait(100)
      this.cargando = true
      let custodias = (await Api.find('custodia', [], {
        subset: [{
          'coleccion': 'equipo',
          'query': '_id,eq,',
          'sustituir': 'idEquipo',
          'unico': true
        }, {
          'coleccion': 'ejecutante',
          'query': '_id,eq,',
          'sustituir': 'idAutor',
          'unico': true
        }],
        sort: ['fecha,-1']
      }))
      let equipos = []
      if (this.filtros.tipoPosesion == 'Cliente' && this.filtros.idCliente != '')
        equipos = (await Api.find('equipo', ['idCliente,eq,' + this.filtros.idCliente]))
      if (this.filtros.tipoPosesion == 'Cliente' && this.filtros.idCliente != '')
        custodias = custodias.filter(c => (c.equipo || {}).idCliente == this.filtros.idCliente)
      if (this.filtros.tipoEquipo != '')
        custodias = custodias.filter(c => (c.equipo || {}).tipo == this.filtros.tipoEquipo)
      if (this.filtros.soloInventariable == true)
        custodias = custodias.filter(c => (c.equipo || {}).inventariable == true)
      for (let i in custodias)
        try {
          custodias[i].cliente = (this.clientes.filter(c => c._id == (custodias[i].equipo || {}).idCliente))[0]
        } catch (e) {
          console.error(e)
        }
      this.piezas = {}
      this.costoTotal = 0
      this.precioTotal = 0
      for (let c of custodias)
        if (c.idEquipo && c.idEquipo.length && !this.piezas[c.idEquipo]) {
          console.log("Indizando", c.idEquipo, c)
          this.piezas[c.idEquipo] = c
          this.costoTotal += parseFloat((c.equipo || {}).costo || 0)
          this.precioTotal += parseFloat((c.equipo || {}).precio || 0)
        }
      console.log("Indizando equipos", equipos.length)
      for (let equipo of equipos)
        if (!this.piezas[equipo._id]) {
          this.piezas[equipo._id] = {
            equipo,
            fecha: equipo.fechaAlta || equipo.fecha,
            idAutor: equipo.idAutor,
            cliente: this.cliente || {},
            idEquipo: equipo._id,
            notas: '(Sin custodia ejecutada)',
            tipoCustodia: 'Alta en sistema',
            _id: Math.random()
          }
          this.piezas[equipo._id].costoTotal += (equipo.costo || 0)
          this.piezas[equipo._id].precioTotal += (equipo.precio || 0)
        }
      let piezasOrdenadas = []
      for (let p in this.piezas)
        piezasOrdenadas.push(this.piezas[p])
      this.piezasOrdenadas = piezasOrdenadas
        .sort((a, b) => a.equipo.modelo > b.equipo.modelo ? 1 : -1)
        .sort((a, b) => a.equipo.marca > b.equipo.marca ? 1 : -1)
      console.log("Buscar?", this.piezas, this.costoTotal, this.precioTotal)
      this.cargando = false
      this.mostrarResultados = true
    },
    async seleccionarTipo() {
      let vm = this
      let id = 'seleccionarTipo' + Math.random()
      console.log("ModalSeleccionarTipoEquipo")
      return this.$ionic.modalController
        .create({
          component: ModalSeleccionarTipoEquipo,
          swipeToClose: true,
          componentProps: {
            parent: vm,
            propsData: {
              //clientes
            }
          }
        })
        .then(m => {
          vm.modals[id] = m
          console.log("ModalSeleccionarTipoEquipo", vm.modals[id])
          vm.modals[id].present()
          vm.modals[id].onDidDismiss(_ => {
            console.log("seleccionarCliente Modal cerrado")
            Api.$off('ModalSeleccionarTipoEquipoCerrar')
            Api.$off('seleccionarTipoEquipo')
          })
          Api.$on('ModalSeleccionarTipoEquipoCerrar', _ => {
            console.log("$on ModalSeleccionarTipoEquipoCerrar")
            vm.modals[id].dismiss()
          })
          Api.$on('seleccionarTipoEquipo', c => {
            console.log("$on seleccionarTipoEquipo", c)
            vm.filtros.tipoEquipo = c
            toast("Tipo seleccionado: " + c)
            vm.$forceUpdate()
            vm.modals[id].dismiss()
          })
        })
    },
    async seleccionarCliente() {
      let vm = this
      let clientes = this.clientes
      let id = 'seleccionarCliente'
      console.log("ModalSeleccionarCliente", clientes)
      return this.$ionic.modalController
        .create({
          component: ModalSeleccionarCliente,
          swipeToClose: true,
          componentProps: {
            parent: vm,
            propsData: {
              clientes
            }
          }
        })
        .then(m => {
          vm.modal = m
          console.log("ModalSeleccionarCliente", vm.modal)
          vm.modal.present()
          vm.modal.onDidDismiss(_ => {
            console.log("seleccionarCliente Modal cerrado")
            Api.$off('ModalSeleccionarClienteCerrar')
            Api.$off('seleccionarCliente')
          })
          Api.$on('ModalSeleccionarClienteCerrar', _ => {
            console.log("$on ModalSeleccionarClienteCerrar")
            vm.modal.dismiss()
          })
          Api.$on('seleccionarCliente', c => {
            //vm.orden.idCliente = c._id
            vm.filtros.idCliente = c._id
            vm.cliente = c
            toast("Cliente seleccionado: " + c.nombre)
            vm.$forceUpdate()
            console.log("$on seleccionarCliente", c.nombre)
            vm.modal.dismiss()
          })
        })
    },

  },
  async mounted() {
    this.tiposEquipos = await TiposEquipos.obtener()
    this.tiposPosesiones = await TiposCustodia.obtener()
    this.clientes = (await Api.get('cliente'))
      .sort((a, b) => a.nombre > b.nombre ? 1 : -1)
      .filter(c => c.nombre && c.nombre != '')
    this.empresa = (await Api.get('empresa'))[0] || {}
    this.cargando = false
  }
}
</script>
